import React, {FC} from 'react'
import {Check, Tooltip} from '@mdsol/onex-design'
import {useSelector} from 'react-redux'
import {useAppDispatch} from 'redux/config'
import {toggleAllPermissibleJobsForRescheduling} from 'redux/jobs/rescheduleJobs.duck'
import {
  select_jobs_areThereJobsPermissibleForRescheduling,
  select_rescheduleJobs_allSelected,
  select_rescheduleJobs_indeterminate,
} from 'redux/jobs/selectors'

const SelectAllRowsCell: FC = () => {
  const dispatch = useAppDispatch()

  const areThereJobsPermissibleForRescheduling = useSelector(select_jobs_areThereJobsPermissibleForRescheduling)
  const isRescheduleAllPermissibleJobsIndeterminate = useSelector(select_rescheduleJobs_indeterminate)
  const isRescheduleAllPermissibleJobsChecked = useSelector(select_rescheduleJobs_allSelected)

  const tooltipMessage = areThereJobsPermissibleForRescheduling
    ? isRescheduleAllPermissibleJobsChecked
      ? 'All permissible jobs selected for rescheduling'
      : 'Reschedule all permissible jobs'
    : ''

  const handleRescheduleAllChange = () => {
    dispatch(toggleAllPermissibleJobsForRescheduling())
  }

  return (
    <Tooltip
      id='reschedule-all-jobs-tooltip'
      tooltipChildren={tooltipMessage}
      placement='bottom-start'
    >
      <Check
        dataTestId='reschedule-all-checkbox'
        disabled={!areThereJobsPermissibleForRescheduling}
        checked={isRescheduleAllPermissibleJobsChecked}
        indeterminate={isRescheduleAllPermissibleJobsIndeterminate}
        onChange={handleRescheduleAllChange}
      />
    </Tooltip>
  )
}

export default SelectAllRowsCell
